const googlePlacesApiKey = 'AIzaSyBmj9LSvesg3M5cq4ei1sYZhGsxOi7Y0fs';
const projectName = 'Region im Netz';

interface ShippingCompany {
  key: string;
  title: string;
  url: string;
}

const ShippingCompanies: ShippingCompany[] = [
  {
    key: 'post',
    title: 'Österreichische Post',
    url: 'https://www.post.at/s/sendungssuche?snr={{ID}}'
  },
  {
    key: 'dhl',
    title: 'DHL',
    url: 'https://www.dhl.com/at-de/home/sendungsverfolgung.html?tracking-id={{ID}}&submit=1'
  },
  {
    key: 'hermes',
    title: 'Hermes',
    url: 'https://www.myhermes.at/sendungsverfolgung/trackingnummer/{{ID}}/#trackingdetailsansicht'
  },
  {
    key: 'ups',
    title: 'UPS',
    url: 'https://www.ups.com/track?loc=de_AT&tracknum={{ID}}&requester=ST/'
  },
  {
    key: 'fedex',
    title: 'FedEx',
    url: 'https://www.fedex.com/wtrk/track/?trknbr={{ID}}'
  },
  {
    key: 'dpd',
    title: 'DPD',
    url: 'https://www.mydpd.at/'
  },
  {
    key: 'sendcloud',
    title: 'Sendcloud',
    url: ''
  }
];

export default {
  GOOGLE_PLACES_API_KEY: googlePlacesApiKey,
  projectName,
  ShippingCompanies
};
